module.exports = __webpack_public_path__ + "../resources/images/CombinedDndFRE-a17f5c47550e623da01e264e25aae847.gif";